import ChangePassword from "views/ChangePassword";
import Interpreters from "views/interpreters/Interpreters";
import Dashboard from "views/Dashboard";
import Facility from "views/tools/Facility";
import Department from "views/tools/Department";
import ClientType from "views/clients/Accounts";
import ExtensionsList from "views/Extensions";
import { AppointmentRoutes } from "views/Appointment";
import InvoicePayments from "views/InvoicePayments";
import LanguageList from "views/settings/language";
import StateList from "views/settings/state";
import CityList from "views/settings/city";
import LanguageTiersList from "views/settings/languageTiers";
import CreateAccount from "views/clients/accounts/Create";
import UpdateAccount from "views/clients/accounts/Update";
import ClientTemplates from "views/clients/Templates";
import CreateTemplate from "views/clients/templates/Create";
import UpdateTemplate from "views/clients/templates/Update";
import InvoiceAppointmentDetail from "views/InvoicePayments/InvoiceApptDetail";
import PermissionGroups from "views/permissions/Groups";
import PermissionSubUser from "views/permissions/SubUsers";
import UpdateGroup from "views/permissions/groups/Update";
import CreateGroup from "views/permissions/groups/Create";
import PdfView from "views/InvoicePayments/PdfView";
import AllPdfView from "views/AllInvoices/PdfView";
import EditAllPdfView from "views/AllInvoices/EditPdfView";
import InvoiceHistory from "views/AllInvoices/InvoiceHistory";
import InvocieList from "views/AllInvoices/AllInvoices";
import InvoiceIssues from "views/InvoiceIssues/InvoiceIssues";
import InterpreterCreate from "views/interpreters/Create";
import InterpreterUpdate from "views/interpreters/Update";
import IntepreterPayments from "views/Payments/InterpreterPayments";
import IntepreterPaymentsStatement from "views/Payments/InterpreterPaymentsStatement";
import InterpreterTimesheets from "views/InterpreterTimesheets";
import StaffTimesheets from "views/StaffTimesheets";
import AppointmentRequests from "views/AppointmentRequests";
import Chat from "views/Chat";

import Translation from "views/Translation/Translation";
import AddTranslatoinForm from "views/AddTranslationForm/AddTranslatoinForm";
import TranslationView from "views/Translation/TranslationView";
import InviteTranslators from "views/Translation/InviteTranslators";
import AppointmentRequestView from "views/AppointmentRequestView";
import LanguageRequests from "views/LanguageRequests";
import LanguageRequestView from "views/LanguageRequestView";

var routes = [
  {
    path: "",
    title: "Dashboard",
    titleKey: "sidebar.dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/",
  },
  {
    path: "language-requests",
    title: "Language Requests",
    titleKey: "sidebar.languageRequests",
    subRoute: true,
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <LanguageRequests />,
    layout: "",
  },
  {
    path: "appointment-requests",
    title: "Appointment Requests",
    titleKey: "sidebar.appointmentRequests",
    subRoute: true,
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentRequests />,
    layout: "",
  },
  {
    path: "/appointment-requests/view/:id",
    subRoute: true,
    component: <AppointmentRequestView />,
    layout: "/user",
  },
  {
    path: "/language-requests/view/:id",
    subRoute: true,
    component: <LanguageRequestView />,
    layout: "/user",
  },
  // {
  //   path: "appointments",
  //   title: "Appointments",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <AppointmentRoutes />,
  //   layout: "",
  // },
  {
    path: "translation",
    title: "Translations",
    titleKey: "sidebar.translations",
    subRoute: false,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <Translation />,
    layout: "/",
  },
  {
    path: "translation/view/:id",
    subRoute: true,
    component: <TranslationView />,
    layout: "/",
  },
  {
    path: "/translation/create",
    subRoute: true,
    component: <AddTranslatoinForm />,
    layout: "/",
  },
  {
    path: "billings",
    title: "Billing",
    titleKey: "sidebar.billing",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <InvoicePayments />,
    layout: "",
  },
  {
    path: "billings/detail/:id",
    subRoute: true,
    component: <InvoiceAppointmentDetail />,
    layout: "/admin",
  },
  {
    path: "billings/pdf-view/:id",
    subRoute: true,
    component: <PdfView />,
    layout: "/admin",
  },
  {
    path: "invoices",
    title: "Invoices",
    titleKey: "sidebar.invoices",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <InvocieList />,
    layout: "",
  },
  {
    path: "invoice-issues",
    title: "Invoice Issues",
    titleKey: "sidebar.invoiceIssues",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <InvoiceIssues />,
    layout: "",
  },
  {
    path: "invoices/pdf-view/:id",
    subRoute: true,
    component: <AllPdfView />,
    layout: "/admin",
  },
  {
    path: "invoices/history/:id",
    subRoute: true,
    component: <InvoiceHistory />,
    layout: "/admin",
  },
  {
    path: "invoices/edit-view/:id",
    subRoute: true,
    component: <EditAllPdfView />,
    layout: "/admin",
  },
  {
    path: "clients/accounts",
    title: "Accounts",
    titleKey: "sidebar.accounts",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <ClientType />,
    layout: "",
  },
  {
    path: "clients/accounts/create",
    subRoute: true,
    component: <CreateAccount />,
    layout: "/admin",
  },
  {
    path: "clients/accounts/update/:id",
    subRoute: true,
    component: <UpdateAccount />,
    layout: "/admin",
  },
  {
    path: "clients/templates",
    title: "Templates",
    titleKey: "sidebar.templates",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <ClientTemplates />,
    layout: "",
  },
  {
    path: "clients/templates/create",
    subRoute: true,
    component: <CreateTemplate />,
    layout: "/admin",
  },
  {
    path: "clients/templates/update/:id",
    subRoute: true,
    component: <UpdateTemplate />,
    layout: "/admin",
  },
  {
    path: "interpreters",
    title: "Vendors",
    titleKey: "sidebar.vendors",
    icon: "/images/calendar-view.png",
    iconActive: "/images/calendar-view.png",
    component: <Interpreters />,
    layout: "/",
  },
  {
    path: "interpreters/create",
    subRoute: true,
    component: <InterpreterCreate />,
    layout: "/admin",
  },
  {
    path: "interpreters/update/:id",
    subRoute: true,
    component: <InterpreterUpdate />,
    layout: "/admin",
  },
  {
    path: "payments",
    title: "Payments",
    titleKey: "sidebar.payments",
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <IntepreterPayments />,
    layout: "",
  },
  {
    path: "payments-statements",
    title: "Payments Statements",
    titleKey: "sidebar.paymentsStatements",
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <IntepreterPaymentsStatement />,
    layout: "",
  },
  {
    path: "interpreter-timesheet",
    title: "Vendor Timesheet",
    titleKey: "sidebar.vendorTimesheet",
    icon: "/images/calendar-days-regular-full.svg",
    iconActive: "/images/calendar-days-solid-full.svg",
    component: <InterpreterTimesheets />,
    layout: "",
  },
  {
    path: "staff-timesheet",
    title: (role) => role === "admin" ? "sidebar.staffTimesheet" : "sidebar.timesheet",
    titleKey: "sidebar.staffTimesheet",
    icon: "/images/calendar-days-regular-full.svg",
    iconActive: "/images/calendar-days-solid-full.svg",
    component: <StaffTimesheets />,
    layout: "",
  },
  // {
  //   path: "extensions",
  //   title: "Extensions",
  //   icon: "/images/calendar-view.png",
  //   iconActive: "/images/calendar-view.png",
  //   component: <ExtensionsList />,
  //   layout: "/",
  // },
  {
    path: "permissions/groups",
    title: "Groups",
    titleKey: "sidebar.groups",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <PermissionGroups />,
    layout: "/",
  },
  {
    path: "permissions/groups/create",
    subRoute: true,
    component: <CreateGroup />,
    layout: "/admin",
  },
  {
    path: "permissions/groups/update/:id",
    subRoute: true,
    component: <UpdateGroup />,
    layout: "/admin",
  },

  {
    path: "permissions/sub-users",
    title: "Sub Users",
    titleKey: "sidebar.subUsers",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <PermissionSubUser />,
    layout: "",
  },
  // {
  //   path: "tools/facility",
  //   title: "Facility",
  //   subRoute: true,
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <Facility />,
  //   layout: "/",
  // },
  // {
  //   path: "tools/department",
  //   title: "Department",
  //   subRoute: true,
  //   icon: "/images/admin.png",
  //   iconActive: "/images/admin-active.png",
  //   component: <Department />,
  //   layout: "",
  // },
  {
    path: "settings/city",
    subRoute: true,
    component: <CityList />,
    layout: "/admin",
  },
  {
    path: "settings/state",
    subRoute: true,
    component: <StateList />,
    layout: "/admin",
  },
  {
    path: "settings/languages",
    subRoute: true,
    component: <LanguageList />,
    layout: "/admin",
  },
  {
    path: "settings/language-tiers",
    subRoute: true,
    component: <LanguageTiersList />,
    layout: "/admin",
  },
  {
    path: "change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/",
  },
    {
    path: "/translation/invite-translators/:id",
    subRoute: true,
    component: <InviteTranslators />,
    layout: "/",
  },
  // {
  //   path: "chat",
  //   title: "Chat",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <Chat />,
  //   layout: "",
  // },
];
export default routes;
